module.exports = __webpack_public_path__ + "img/nav3.97b2a0c1.png";